import React from 'react';

const Spinner = () => <div data-e2e='widget_loader' className='loading' />;

export default Spinner;
